<template>
  <div class="content">
    <base-header class="pb-6 bg-gradient" type="">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0" v-if="!loading">
            Angebot Nr. {{ this.offer.internal_id }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">

<div class="loader" v-if="loading"></div>
      <!-- div class="row">
        <div class="col-xl-4 col-md-6" v-on:click="editOffer(offer.id)">
          <div class="card card-stats border-0" show-footer-line="true">
           
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">
                    Angebot
                  </h5>
                  <span class="h2 font-weight-bold mb-0"
                    >Kalkualtion bearbeiten</span
                  >
                </div>
                <div class="col-auto">
                  <div
                    class="
                      icon icon-shape
                      text-white
                      rounded-circle
                      shadow
                      bg-gradient-blue
                    "
                  >
                    <i class="fas fa-edit"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <span class="text-success mr-2"
                  ><i class="fa fa-edit"></i> </span
                ><span class="text-nowrap">Kalkulationswerte anpassen</span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-xl-4 col-md-6" v-on:click="retrieveOfferPdf(offer.id, 'Angebot.pdf')">
          <div class="card card-stats border-0" show-footer-line="true">
            
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">
                    Angebot
                  </h5>
                  <span class="h2 font-weight-bold mb-0"
                    >Angebot herunterladen</span
                  >
                </div>
                <div class="col-auto">
                  <div
                    class="
                      icon icon-shape
                      text-white
                      rounded-circle
                      shadow
                      bg-gradient-blue
                    "
                  >
                    <i class="fas fa-file-pdf"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <span class="text-success mr-2"
                  ><i class="fa fa-file-pdf"></i> </span
                ><span class="text-nowrap"
                  >Angebot_{{ this.offer.id }}.pdf</span
                >
              </p>
            </div>
            
          </div>
        </div>
        <div class="col-xl-4 col-md-6" v-on:click="alert('BLA')">
          <div class="card card-stats border-0" show-footer-line="true">
           
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0">
                    Verbindlich akzeptieren
                  </h5>
                  <span class="h2 font-weight-bold mb-0">Zum Antrag</span>
                </div>
                <div class="col-auto">
                  <div
                    class="
                      icon icon-shape
                      text-white
                      rounded-circle
                      shadow
                      bg-gradient-blue
                    "
                  >
                    <i class="fas fa-file-contract"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <span class="text-success mr-2"
                  ><i class="fa fa-sign"></i> </span
                ><span class="text-nowrap">Kundendaten ergänzen</span>
              </p>
            </div>
          </div>
        </div>
      </div -->

      <div>
        


    <b-row class="card-wrapper">

      <b-col :lg="offerWidth" v-if="show_kravag">

        <div class="loader" v-if="!kravag_ready"></div>
        <!-- Pricing -->
        <card
          gradient=""
          header-classes="bg-transparent"
          footer-classes="bg-transparent"
          body-classes="px-lg-7"
          class="card-pricing border-0 text-center mb-4"
        >
          <!--Header-->
          <h4 slot="header" class="text-uppercase ls-1 py-3 mb-0">
            Kravag
          </h4>

          
          <!--Card Body-->
          <div class="display-2">{{ this.offer.pricing.price_brut_complete | toCurrency }} €</div>
          <span class="">Gesamt brutto</span>
          <ul class="list-unstyled my-4">
            <li>
              <!-- div class="d-flex align-items-center">
                weiterer text hier
              </div -->
            </li>
          </ul>

        <div slot="footer">

          
          <base-button type="success" class="mb-3" @click="acceptOffer(offer.id)" v-if="this.offer.kravag_state == 'calculated'"><i class="fas fa-check"></i> Jetzt annehmen</base-button>

          <base-button type="primary" class="mb-3" @click="editOffer(offer.id)" v-if="this.offer.kravag_state == 'calculated'"><i class="fas fa-edit"></i> Jetzt anpassen</base-button>

          <base-button type="primary" class="mb-3" @click="acceptOffer(offer.id)" v-if="this.offer.kravag_state == 'tlp_saved' || this.offer.kravag_state == 'api_saved' || this.offer.kravag_state == 'consent'"><i class="fas fa-edit"></i> Vertragsdaten ergänzen</base-button>

          <base-button type="warning" class="mb-3" @click="downloadFile(offer.id, 'offer')"><i class="fas fa-file-pdf"></i> Angebot herunterladen</base-button>

          <base-button type="info" class="mb-3" @click="downloadFile(offer.id, 'contract')" v-if="this.offer.kravag_state == 'tlp_saved' || this.offer.kravag_state == 'api_saved' || this.offer.kravag_state == 'consent' || this.offer.kravag_state == 'submitted'"><i class="fas fa-file-pdf"></i> Antrag herunterladen</base-button>

          <base-button type="info" class="mb-3" @click="acceptContract(offer.id)" v-if="this.offer.kravag_state == 'tlp_saved' || this.offer.kravag_state == 'api_saved' || this.offer.kravag_state == 'consent'"><i class="fas fa-file-pdf"></i> Antrag abschließen</base-button>

          <!-- base-button type="primary" class="mb-3" @click="private_customer = true; offer.is_car = true; startCalc()"
            ><i class="fas fa-file-pdf"></i> PDF laden</base-button
          -->
        </div>

        </card>
      </b-col>



      <!-- b-col lg="6" v-if="show_janitos">
        <div class="loader" v-if="true"></div>
        <card
          gradient=""
          header-classes="bg-transparent"
          footer-classes="bg-transparent"
          body-classes="px-lg-7"
          class="card-pricing border-0 text-center mb-4"
        >
        
          <h4 slot="header" class="text-uppercase ls-1 py-3 mb-0">
            Janitos
          </h4>

          
          
          <div class="display-2">wird geladen...</div>
          <span class="">bitte warten</span>
          <ul class="list-unstyled my-4">
            <li>
              <div class="d-flex align-items-center">
                weiterer text hier
              </div>
            </li>
          </ul>

        <div slot="footer">
          <base-button type="success" class="mb-3" @click="acceptOffer(offer.id)"><i class="fas fa-check"></i> Jetzt annehmen</base-button>
          <base-button type="primary" class="mb-3" @click="editOffer(offer.id)"><i class="fas fa-edit"></i> Jetzt anpassen</base-button>

        </div>

        </card>
      </b-col -->
    </b-row>



        <!-- b-row class="card-wrapper">
          <b-col lg="12">
            <card>
              <template slot="header"
                >Angebot Nr. {{ offer.internal_id }}
              </template>



                Ihr Preis:
                <br>
                {{ this.offer.pricing.price_brut_complete }} €
                
            </card>
          </b-col>
        </b-row -->
        <modal :show.sync="modals.notice" :showClose="true" @ok="handleOk"
                   modal-classes="modal-default"
                   modal-content-classes="bg-gradient-info">

                   <h6 slot="header" class="modal-title">
                <i class="fas fa-file"></i>
                Vertrag abschicken & bestätigen
              </h6>

              <b-row>
                    <b-col md="12">
                      <b-form-checkbox class="mb-3" v-model="checkboxes.sepa" v-if="(offer.kravag_payment_mode == 'Lastschrift')">
                        Der Versicherungsnehmer stimmt dem Sepa-Verfahren zu und hat das Sepa Mandat unterschrieben
                      </b-form-checkbox>
                      <br>
                      <b-form-checkbox class="mb-3" v-model="checkboxes.bedingungen">
                        Der Versicherungsnehmer hat die Bedingungen zur Kenntnis genommen und stimmt diesen zu
                      </b-form-checkbox>
                      <br>
                      <b-form-checkbox class="mb-3" v-model="checkboxes.signage">
                        Der Versicherungsnehmer hat den Versicherungsantrag unterschrieben und hat die darin enthaltenen Daten bestätigt 
                      </b-form-checkbox>

                    </b-col>
              </b-row>

              <template slot="footer">

                  <div class="btn-wrapper text-center">

                    <base-button type="primary" class="btn btn-primary" v-if="(offer.kravag_payment_mode == 'Lastschrift' && checkboxes.sepa && checkboxes.bedingungen && checkboxes.signage) || (offer.kravag_payment_mode != 'Lastschrift' && checkboxes.bedingungen && checkboxes.signage)">
                      <span class="btn-inner--text" @click="handleAvo()">Antrag Abschliessen</span>
                    </base-button>

                  </div>

              </template>

            </modal>
      
      </div>
    </b-container>
  </div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import {
  Table,
  TableColumn,
  Select,
  Option,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import LightTable from "../Tables/RegularTables/LightTable";
import { TablePlugin } from "bootstrap-vue";

import { TimeLine, TimeLineItem } from "@/components";
import Badge from "@/components/Badge";
import { Modal, BaseAlert } from '@/components'
  import swal from 'sweetalert2';
import { Tabs, TabPane } from "@/components";

import dateUtil from "../../services/date";
import offerUtil from "../../services/offer";

import moment from "moment";


export default {
  components: {
    RouteBreadCrumb,
    LightTable,
    Badge,
    Modal,
    TimeLine,
    TimeLineItem,
    Tabs,
    TabPane,
    dateUtil,

    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: true,
      selectedRows: [],
      offer: {},
      kravag_ready: false,
      janitos_ready: false,
      show_kravag: true,
      show_janitos: true,
      insurances: ['kravag','janitos'],
      modals: {
          notice: false,
        },
        checkboxes: {
          signage: false,
          bedingungen: false,
          sepa: false,
        },
    };
  },
  props: {
    token: String,
    tab: String,
  },
  filters: {
    toCurrency: function (value) {

    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(value);
    },
  },
  methods: {

    retrieveOffer(token) {

      console.log("RETRIVING OFFER");


      this.loading = true;
      this.$api
        .getOffer(token)
        .then((response) => {
          this.offerdata = response.data.offer;
          this.offer = response.data.offer;
          this.kravag_ready = true;
          console.log(this.offer);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fileName(str) {
      var file = str.split("/").pop();
      return file;
    },

    retrieveOfferPdf(id, name) {
      
      this.loading = true;
      this.$api
        .getOfferDocument(id)
        .then((response) => {
          const blob = new Blob([response.data]);
          const objectUrl = window.URL.createObjectURL(blob);
          window.open(objectUrl);
          this.loading = false;
        })
        .catch(console.error);
    },

    retrieveContractPdf(id, name) {
      this.loading = true;
      this.$api
        .getOfferDocument(id)
        .then((response) => {
          const blob = new Blob([response.data]);
          const objectUrl = window.URL.createObjectURL(blob);
          window.open(objectUrl);
          this.loading = false;
        })
        .catch(console.error);
    },

    downloadFile(id, name) {
      this.loading = true;
      this.$api
        .getOfferDocument(id, name)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const objectUrl = window.URL.createObjectURL(blob);
          window.open(objectUrl);
          this.loading = false;
        })
        .catch(console.error);
    },

/**
 * 
 * 
downloadFile(id, name) {
      this.$api
        .getOfferDocument(id, name)
        .then((response) => {
        //  console.log(response);
        //  console.log(this.fileName(name));
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement("a");
         
         //link.href = URL.createObjectURL(blob);
          //link.setAttribute("download", this.fileName(name));
          //link.click();
          //URL.revokeObjectURL(link.href);

                //const blob = new Blob([response.data], { type: 'application/pdf' })
      const objectUrl = window.URL.createObjectURL(blob);
      window.open(objectUrl);


        })
        .catch(console.error);
    },

 */

    editOffer(){

      if(this.offer.state == 'accepted'){
      this.$router.push({
        name: "Angebot annehmen",
        params: { token: `${this.offer.id}` },
      });
      }
      else{
      this.$router.push({
        name: "Angebot bearbeiten",
        params: { token: `${this.offer.id}`, tab: "Dokumente" },
      });
      }

  },


    acceptOffer(){

      this.$router.push({
        name: "Angebot annehmen",
        params: { token: `${this.offer.id}` },
      });
  },

  acceptContract(){
    this.offer.showAcceptContract = true;
    this.modals.notice = true;
},

handleAvo() {
    this.modals.notice = false;
      this.loading = true;
      this.$api
        .submitContract(this.offer)
        .then((response) => {
          console.log(response);
          this.retrieveOffer(this.$route.params.token);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
          this.showSwal("Vielen Dank", "Antrag erfolgreich eingereicht.","success");
        });
    },

    showSwal(title, text, icon) {
          swal.fire({
            title: title,
            text: text,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            icon: icon,
            timer: 1500,
          })
        },

  },
  channels: {
    OffersChannel: {
      connected() {
        //console.log('I am connected to offers');
      },
      rejected() {
        //console.log('I am REJECTED.');
      },
      received(data) {
                console.log("RECEIVED!");
                console.log(data);
      },
      disconnected() {
        console.log("I am disconnected.");
      },
    },
  },
  computed: {
    offerWidth() {
      if(this.insurances.length > 1){
        return 6;
      }
      else{
        return 12;
      }
    },
  },
  mounted() {



   console.log('The token is: ' + this.$route.params.token);
   console.log(this.token);

if (this.$route.params.token){
     this.retrieveOffer(this.$route.params.token);
   }

/*   if (this.$route.params.token){
     this.$store.dispatch('fetchOffer',this.$route.params.token);
   }
*/

    this.$cable.subscribe({
      channel: "OffersChannel",
      offer_id: this.token,
    });
  //  this.retrieveOffer();

    setTimeout(()=>{
   this.show_janitos = false;
  // console.log(this.insurances.length);
  // console.log(this.insurances);
   this.insurances = ['kravag'];
//   delete this.insurances['janitos'];
  // console.log(this.insurances.length);
  // console.log(this.insurances);
},0);

//},2500);



  },
  created() {},
};
</script>